// extracted by mini-css-extract-plugin
module.exports = {"root":"_1MzgeD-hx-6gNHz8aOszvV","close":"_11yyUtxr03Y-hBwYJ-55Dk","app-icon-holder":"_2sW6OSov52E2TYQvvxBtsL","content":"_2QzJrlqeBMPSJJOD_q41Zp"};